import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { checkDatasetValidationService } from "../services/chats";
import { useSetFileTrack } from "./useSetFileTrack";
import { SOCKET_STATUS } from "constants/common.constants";

const DEFAULT_VALIDATION_STATE = {
  isReady: false,
  loading: false,
  data: null,
  enabledForValidation: false,
  isOpenValidationScreen: false,
  dataset: null,
};

export const useDatasetValidationCheck = () => {
  const [validationStatus, setValidationStatus] = useState(DEFAULT_VALIDATION_STATE);

  const tempDatasetId = useSelector((state) => state.chatsReducer.tempDatasetId);

  const { validationLoading, response, setResponse } = useSetFileTrack({
    dataset_id: tempDatasetId,
    token: localStorage.getItem("session_token"),
  });

  // Get active dataset from Redux state
  const activeDataset = useSelector((state) => state.chatsReducer.activeDataset);
  const activeDatasetId = validationStatus?.dataset?.id || activeDataset?.id;

  const onOpenValidationScreen = (dataset) => {
    setValidationStatus((prev) => ({ ...prev, isOpenValidationScreen: true, dataset }));
  };

  const onCloseValidationScreen = () => {
    const dataset_id = validationStatus?.dataset?.id || activeDatasetId;
    if (response && dataset_id === response?.dataset_id) {
      setValidationStatus(DEFAULT_VALIDATION_STATE);
      setResponse(null);
    } else {
      setValidationStatus({ ...DEFAULT_VALIDATION_STATE, enabledForValidation: true });
    }
  };

  const onGetValidation = async () => {
    if (!activeDatasetId) {
      setValidationStatus((prev) => ({ ...prev, loading: false }));
      return;
    }

    setValidationStatus((prev) => ({ ...prev, loading: true }));

    try {
      const response = await checkDatasetValidationService(activeDatasetId);
      setValidationStatus((prev) => ({
        ...prev,
        isReady: true,
        loading: false,
        data: response.data,
      }));

      //stopValidationCheck();
    } catch (error) {
      console.log(error);
      // Don't set error for aborted requests
      setValidationStatus((prev) => ({
        ...prev,
        isReady: false,
        loading: false,
      }));
    }
  };

  const onEnableValidation = () => {
    setValidationStatus((prev) => ({ ...prev, enabledForValidation: true }));
  };

  useEffect(() => {
    if (
      validationStatus.enabledForValidation &&
      activeDatasetId &&
      response?.event === SOCKET_STATUS.READY_VALIDATION &&
      validationStatus.isOpenValidationScreen &&
      activeDatasetId === response?.dataset_id
    ) {
      onGetValidation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeDatasetId,
    validationStatus.enabledForValidation,
    response?.event,
    validationStatus.isOpenValidationScreen,
  ]);

  return {
    validationStatus,
    activeDatasetId,
    checkValidation: onGetValidation,
    onOpenValidationScreen,
    onCloseValidationScreen,
    onEnableValidation,
    socketLoading: validationLoading,
    socketResponse: response,
    setResponse,
    response,
  };
};
